function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: 0.5,
  x2: 0.5,
  y2: 1,
  gradientUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fa7272"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#f80000"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_191",
  "data-name": "Path 191",
  d: "M128.991,160.9a2.311,2.311,0,0,0,1.639.7,2.246,2.246,0,0,0,1.639-.7l12.721-12.721L157.71,160.9a2.311,2.311,0,0,0,1.639.7,2.246,2.246,0,0,0,1.639-.7,2.379,2.379,0,0,0,0-3.317L148.306,144.9l12.682-12.721a2.379,2.379,0,0,0,0-3.317,2.343,2.343,0,0,0-3.317,0L144.99,141.581,132.269,128.9a2.345,2.345,0,0,0-3.317,3.317L141.673,144.9l-12.682,12.721A2.263,2.263,0,0,0,128.991,160.9Z",
  transform: "translate(-100.001 -99.905)",
  fill: "url(#linear-gradient)"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Path_192",
  "data-name": "Path 192",
  d: "M45,90A45,45,0,1,0,0,45,45.037,45.037,0,0,0,45,90ZM45,6.129A38.871,38.871,0,1,1,6.129,45,38.89,38.89,0,0,1,45,6.129Z",
  fill: "url(#linear-gradient)"
});

function SvgErrorCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_108",
    "data-name": "Group 108",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircle);
export default __webpack_public_path__ + "static/media/error-circle.929783bc.svg";
export { ForwardRef as ReactComponent };